module.exports = (__webpack_require__(0))(61);


//////////////////
// WEBPACK FOOTER
// delegated ./src/models/FileModel.js from dll-reference girder_lib
// module id = 34
// module chunks = 0